export const SET_ZONESTR = 'SET_ZONESTR';
export const SET_ZONEARY = 'SET_ZONEARY';
export const SET_PROMPTS = 'SET_PROMPTS';
export const SET_COORDINATE = 'SET_COORDINATE';
export const SET_FULL_ADDRESS = 'SET_FULL_ADDRESS';
export const SET_COUNTRY_NAME = 'SET_COUNTRY_NAME';
export const SET_MAP_CITY_NAME = 'SET_MAP_CITY_NAME';
export const SET_EXAMPLEADDRESS = 'SET_EXAMPLEADDRESS';
export const SET_GOOGLESEARCHTERM = 'SET_GOOGLESEARCHTERM';
